import { translateFn } from '../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../ui/gzForm/validators/required.validator';
import { FormValidator, ValidationResult } from '../../../../../../../../ui/gzForm/formField/types/form-validator';
import { ApplicationControlTargetProcessType } from '@nirvana/shared/dtos/types/policies/common';
import { RegexValidator } from '../../../../../../../../ui/gzForm/validators/regex.validator';
import { MaxLengthValidator } from '../../../../../../../../ui/gzForm/validators/max-length.validator';

// get validators for type field
export const typeValidators = (): FormValidator<string>[] => {
  return [RequiredValidator(translateFn('Required field'))];
};

// get validators for description field
export const descriptionValidators = (): FormValidator<string>[] => {
  return [MaxLengthValidator(256, translateFn('Maximum number of characters exceeded'))];
};

export async function matchValidatorsByType(
  type: ApplicationControlTargetProcessType,
  value: string
): Promise<ValidationResult> {
  switch (type) {
    case ApplicationControlTargetProcessType.PATH:
      return { valid: true };
    case ApplicationControlTargetProcessType.HASH:
      return await RegexValidator(/^[0-9A-Fa-f]{80}$/, translateFn('Invalid hash format'))(value);
    case ApplicationControlTargetProcessType.CERTIFICATE:
      return await RegexValidator(/^[0-9A-Fa-f]{64}$/, translateFn('Invalid certificate format'))(value);
    default:
      return { valid: true };
  }
}
